export default "__VITE_ASSET__D3yo3mgT__"